function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as React from "react";
var SvgSolana = function SvgSolana(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22182_32168)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.09881 13.9763C3.21951 13.8556 3.38546 13.7852 3.56148 13.7852H19.5233C19.8149 13.7852 19.9608 14.1372 19.7546 14.3434L16.6015 17.4965C16.4808 17.6172 16.3148 17.6876 16.1388 17.6876H0.177014C-0.114663 17.6876 -0.260501 17.3356 -0.0543158 17.1294L3.09881 13.9763Z",
    fill: "url(#paint0_linear_22182_32168)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.09881 2.20355C3.22454 2.08286 3.39049 2.01245 3.56148 2.01245H19.5233C19.8149 2.01245 19.9608 2.36448 19.7546 2.57066L16.6015 5.72379C16.4808 5.84449 16.3148 5.91489 16.1388 5.91489H0.177014C-0.114663 5.91489 -0.260501 5.56287 -0.0543158 5.35668L3.09881 2.20355Z",
    fill: "url(#paint1_linear_22182_32168)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6015 8.05218C16.4808 7.93149 16.3148 7.86108 16.1388 7.86108H0.177014C-0.114663 7.86108 -0.260501 8.21311 -0.0543158 8.41929L3.09881 11.5724C3.21951 11.6931 3.38546 11.7635 3.56148 11.7635H19.5233C19.8149 11.7635 19.9608 11.4115 19.7546 11.2053L16.6015 8.05218Z",
    fill: "url(#paint2_linear_22182_32168)",
    style: {}
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_22182_32168",
    x1: 17.9984,
    y1: 0.128867,
    x2: 6.95162,
    y2: 21.288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3",
    style: _defineProperty(_defineProperty({
      stopColor: "#00FFA3"
    }, "stopColor", "color(display-p3 0.0000 1.0000 0.6392)"), "stopOpacity", 1)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF",
    style: _defineProperty(_defineProperty({
      stopColor: "#DC1FFF"
    }, "stopColor", "color(display-p3 0.8627 0.1216 1.0000)"), "stopOpacity", 1)
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_22182_32168",
    x1: 13.1682,
    y1: -2.39295,
    x2: 2.12134,
    y2: 18.7662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3",
    style: _defineProperty(_defineProperty({
      stopColor: "#00FFA3"
    }, "stopColor", "color(display-p3 0.0000 1.0000 0.6392)"), "stopOpacity", 1)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF",
    style: _defineProperty(_defineProperty({
      stopColor: "#DC1FFF"
    }, "stopColor", "color(display-p3 0.8627 0.1216 1.0000)"), "stopOpacity", 1)
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_22182_32168",
    x1: 15.5679,
    y1: -1.14007,
    x2: 4.5211,
    y2: 20.019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3",
    style: _defineProperty(_defineProperty({
      stopColor: "#00FFA3"
    }, "stopColor", "color(display-p3 0.0000 1.0000 0.6392)"), "stopOpacity", 1)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF",
    style: _defineProperty(_defineProperty({
      stopColor: "#DC1FFF"
    }, "stopColor", "color(display-p3 0.8627 0.1216 1.0000)"), "stopOpacity", 1)
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22182_32168"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }))));
};
export default SvgSolana;